// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/chart-limitations.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/chart-limitations/chart-limitations.js';

mount([g0]);
